import {
    baseUrl
} from '@/config/env';
import request from '@/router/axios';
import {
    parseParam
} from '@/util/util';

export const findEngineeringDynamic = (params) => {
    params = parseParam(params)
    return request({
        url: `${baseUrl}/joins-sales-cloud/v1/pure_water_goods?` + params,
        method: 'GET'
    })
}
export const findEngineeringDynamicId = (id) => {
    return request({
        url: `${baseUrl}/joins-sales-cloud/v1/pure_water_goods/engineering_goods/${id}`,
        method: 'GET'
    })
}
/**
 * 控件类型列表
 */
export const findDataSourceFields = () => {
    return request({
        url: `${baseUrl}/joins-work/v1/dataSource/fields`,
        method: 'GET'
    })
}
/**
 * 数据源
 */
export const findDataSourceAll = () => {
    return request({
        url: `${baseUrl}/joins-work/v1/dataSource`,
        method: 'GET'
    })
}

export const addDynamic = (params) => {
    return request({
        url: `${baseUrl}/joins-sales-cloud/v1/pure_water_goods/engineering_goods`,
        method: 'POST',
        data: params
    })
}
export const editEngineeringDynamic = (params) => {
    return request({
        url: `${baseUrl}/joins-sales-cloud/v1/pure_water_goods/engineering_goods`,
        method: 'PUT',
        data: params
    })
}

export const delProject = (deleteOption, ids) => {
    let temp = ids.join(",")
    return request({
        url: `${baseUrl}/joins-sales-cloud/v1/pure_water_goods/${temp}?option=${deleteOption}`,
        method: 'DELETE'
    })
}